import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=1112b514&lang=pug&"
import script from "./MainFooter.vue?vue&type=script&lang=ts&"
export * from "./MainFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports